import { css } from 'styled-components';
import token from 'styled-token';
import { StyledButtonIcon } from '../../components/ButtonIcon/ButtonIcon.styles';
import { BUTTON_TYPES } from '../../constants';
import { spaceMixin } from '../spaceMixin';

/** @class PropertyCardSaveButtonMixin */
/** @method */
export var PropertyCardSaveButtonMixin = function PropertyCardSaveButtonMixin(props) {
  return token({
    iconColors: ["Button." + BUTTON_TYPES.secondary + "Inverse"],
    iconFill: 'PropertyCard.saveButton.icon.fill.default',
    iconFillHover: 'PropertyCard.saveButton.icon.fill.hover',
    iconShadow: 'PropertyCard.saveButton.icon.shadow',
    iconSize: 'PropertyCard.saveButton.icon.size',
    saveButtonBorder: 'PropertyCard.saveButton.border',
    saveButtonPadding: ['PropertyCard.saveButton.padding']
  }, function (_ref) {
    var iconColors = _ref.iconColors,
      iconFill = _ref.iconFill,
      iconFillHover = _ref.iconFillHover,
      iconShadow = _ref.iconShadow,
      iconSize = _ref.iconSize,
      saveButtonBorder = _ref.saveButtonBorder,
      saveButtonPadding = _ref.saveButtonPadding;
    return css(["&&&&&{background-color:transparent;border:", ";padding:", ";}", "{filter:drop-shadow(", ");height:", "px;margin-right:0;width:", "px;.HeartIcon__outline{fill:", ";}.HeartIcon__fill{fill:", ";}}&:hover,&:active,&:focus{.HeartIcon__fill{fill:", ";}}&[aria-pressed='true'],&[aria-label='Unsave']{.HeartIcon__fill{fill:", ";}}"], saveButtonBorder, saveButtonPadding ? saveButtonPadding.top + "px " + saveButtonPadding.right + "px " + saveButtonPadding.bottom + "px " + saveButtonPadding.left + "px" : spaceMixin('xs')(props) + " " + spaceMixin('xs')(props) + "\n                        " + spaceMixin('sm')(props) + " " + spaceMixin('sm')(props), StyledButtonIcon, iconShadow, iconSize, iconSize, iconColors.fontColor, iconFill, iconFillHover, iconColors.fontColor);
  })(props);
};